module.exports = __webpack_public_path__ + "static/img/dkwps2-4.d635d8d.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/dkwps2-4.png
// module id = 668
// module chunks = 0